'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getSelectedText;

var _getContentStateFragment = require('draft-js/lib/getContentStateFragment');

var _getContentStateFragment2 = _interopRequireDefault(_getContentStateFragment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getSelectedText(contentState, selectionState) {
    var fragment = (0, _getContentStateFragment2["default"])(contentState, selectionState);
    return fragment.map(function (block) {
        return block.getText();
    }).join('');
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/.0.1.0@rc-editor-utils/lib/getSelectedText.js
// module id = 330
// module chunks = 0